export default __webpack_public_path__ + "static/media/monsta-wings2.a9eadb20.png";